export interface FileData {
  name: string;
  src: string;
}
